export default __webpack_public_path__ + "static/139-min-min-226e14093e831fedbadab35e2fda371f.jpg";